// 应急保障 记录
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useEffect, useRef } from 'react'
import { Card, Empty, message, theme, Pagination, Button, Popconfirm, Spin, Image } from 'antd'
import { DeleteOutlined, QuestionCircleOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import { getEmergencListAPI, delEmergencListAPI } from '@/server/emergency_support_record.js'
import ShowImgs from './showImg.js'
import { debounce } from '@/common/js/common.js'
import './index.css'

function EmergencySupportRecord () {
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数
  const { token: { colorBgContainer, colorText }, } = theme.useToken(); //获取主题颜色
  const token = localStorage.getItem('dock_token');

  const [loading, setLoading] = useState(false)//加载中···

  const [dataArr, setDataArr] = useState([])
  const [searchList, setSearchList] = useState({//搜索列表
    access_token: token,
    page: 1,
    perpage: 12,
    total: 0,
  });
  const searchListref = useRef({//搜索列表
    access_token: token,
    page: 1,
    perpage: 12,
    total: 0,
  })

  const [showList, setShowList] = useState([]);//显示的图片
  const [showTitle, setShowTitle] = useState([]);//标题
  const [showImg, setShowImg] = useState(false);//是否显示放大的图片
  const [showCurrent, setShowCurrent] = useState(-1);//当前显示的图片下标

  const [isLiftPage, setIsLiftPage] = useState(true);//是否存在上一页
  const [isRightPage, setIsRightPage] = useState(true);//是否存在下一页

  const getAllData = async (search) => { //获取应急保障列表
    setLoading(true)
    let res = await getEmergencListAPI(search)
    setLoading(false)
    if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }
    let data = res.data;
    let img = [];
    let time = [];
    if (data.list && data.list.length > 0) {
      for (let i = 0; i < data.list.length; i++) {
        let val = data.list[i];
        img.push(val.picUrl);
        time.push({ addtime: dayjs(Number(val.addtime * 1000)).format('YYYY-MM-DD HH:mm:ss') });
      }

    }
    setShowList(img);
    setShowTitle(time);

    let sea = search
    sea.total = data.total
    setSearchList({ ...sea });
    searchListref.current = { ...sea };
    setDataArr(data.list);
    if (data.list.length === search.perpage) {
      setIsRightPage(true);
    } else {
      setIsRightPage(false);
    }
    if (search.page === 1) {
      setIsLiftPage(false);
    } else {
      setIsLiftPage(true);
    }
  }

  useEffect(() => {
    getAllData(searchList)

    // eslint-disable-next-line
  }, [])

  return (
    <Card className='mar24 flex jcc' style={{ border: 0, maxHeight: 'calc(100vh - 96px)' }} styles={{ body: { padding: 24 } }}>
      <Spin spinning={loading}>
        <>
          <>{/* 主体 */}
            <div
              className='flex hidden flex_wrap jcsb radius8'
              style={{ maxHeight: 'calc(100vh - 192px)', overflowY: 'auto' }}
            >
              {
                dataArr.length > 0
                  ? (
                    <>
                      {
                        dataArr?.map((ele, index) => {
                          return (
                            <div key={index} className='flex_col marB24' style={{ width: '24%', }}>
                              <img onClick={() => {
                                setShowImg(true);
                                setShowCurrent(index);
                              }}
                                className='wid100 hei100 radius8'
                                src={ele.picUrl}
                                alt='应急图片'
                              />
                              <div className='flex_col marT4'>
                                <div className='flex jcsb align_center h20'>
                                  <span>
                                    {dayjs(Number(ele.addtime * 1000)).format('YYYY-MM-DD HH:mm:ss')}
                                  </span>

                                  <Popconfirm
                                    title="是否删除？"
                                    icon={<QuestionCircleOutlined style={{ color: 'red', }} />}
                                    onConfirm={async () => {
                                      let res = await delEmergencListAPI({ access_token: token, id: ele.id });
                                      if (res.ret !== 200) { message.warning(res.msg); return }
                                      getAllData(searchList)
                                    }}
                                    onCancel={() => { }}
                                    okText="删除"
                                    cancelText="取消"
                                  >
                                    <Button
                                      style={{ padding: 0, margin: 0 }}
                                      type='link'
                                      icon={<DeleteOutlined />}
                                    />
                                  </Popconfirm>
                                </div>
                                <span className='flex_row align_center lh20'>
                                  <span className='opa45 marR4'>{ele.longitude}</span>
                                  <span className='opa25'>|</span>
                                  <span className='opa45 marL4'>{ele.latitude}</span>
                                </span>
                              </div>
                            </div>
                          )
                        })

                      }
                    </>
                  )
                  : (<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />)
              }
            </div>
          </>

          {
            dataArr.length > 0 &&
            <div className='flex jcr Pagination'>
              <Pagination
                align='end'
                total={searchList.total}
                current={searchList.page}
                pageSize={searchList.perpage}
                showQuickJumper
                showSizeChanger={true}
                pageSizeOptions={['12', '24', '48', '96',]}
                showTotal={(total) => `Total ${total} items`}
                onChange={(page, pageSize) => {
                  setLoading(true)
                  let sea = searchList
                  sea.page = page
                  sea.perpage = pageSize
                  setSearchList({ ...sea })
                  searchListref.current = { ...sea };
                  getAllData(sea)
                }}
              />
            </div>
          }
        </>
      </Spin>

      <ShowImgs
        arrData={showTitle}
        picData={showList}
        imgIdx={showCurrent}
        open={showImg}
        pageChange={debounce((e) => {//上一页、下一页回调
          console.log('xxxxx', e, searchListref.current);
          if (e === showList.length) {
            let info = { ...searchListref.current };
            info.page = info.page + 1;
            console.log('下一页', info);

            setSearchList(info);
            searchListref.current = info;
            getAllData(info);
            setShowCurrent(0);
            return;
          }
          if (e === -1) {
            if (searchListref.current.page > 1) {
              let info = { ...searchListref.current };
              info.page = info.page - 1;
              setSearchList(info);
              searchListref.current = info;
              getAllData(info);
              console.log(info);

              setShowCurrent(info.perpage - 1);
              return;
            } else {
              return;
            }
          }
          setShowCurrent(e);
        }, 500)}
        closeChange={(vis) => {
          setShowImg(false);
        }}
        isLiftPage={!(searchList.page === 1 && showCurrent === 0)}
        isRightPage={isRightPage}
      />
    </Card>
  )
}
export default EmergencySupportRecord;